import { useMemo } from "react";
import type { ParsedQuery } from "query-string";
import { parse } from "query-string";
import { useLocation } from "react-router-dom";

export const useRouterQueryParams = (): ParsedQuery<string> => {
  const location = useLocation();

  return useMemo(() => parse(location.search), [location.search]);
};
